<template>
  <div class="animated fadeIn tdpcr">
    <b-card>
      <div slot="header">
        TDP - Contact Report (Silent Disc.)
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="print()">
            <i class="fa fa-print"></i> print
          </b-button>
          <b-button variant="primary mr-1" @click="approvalConfirm()"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i> Filter
          </b-button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <b-button variant="primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Sales Period</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Contact Rpt. No </label></b-input-group-prepend>
            <b-form-input v-model="tblData.nomor" placeholder="CR number"></b-form-input>
            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Paid to</span></b-input-group-prepend>
            <b-form-input v-model="tblData.paidtoname" placeholder="sales order  no"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
            <b-form-input v-model="tblData.customer" ></b-form-input>
            <b-input-group-append>
              <b-btn variant="primary" @click="lkuKoranCustShow=true"> <i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Advertiser</span></b-input-group-prepend>
            <b-form-input v-model="tblData.Advertiser"></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend><label>Sales AE</label></b-input-group-prepend>
            <b-form-input v-model="tblData.sales_search"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuSalesShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
            <b-input-group-prepend><label>Approval </label></b-input-group-prepend>
            <b-form-select v-model="tblData.statuswf" :plain="true" :options="dataList.approvalStatus"></b-form-select>

                <b-input-group-append>
                      <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked" 
      >
        <template v-slot:thead-top="data">
          <b-tr>
            <b-th colspan="11"><span class="sr-only"></span></b-th> 
            <b-th variant="success" colspan="1" class="text-center">PROGRESS</b-th>
            <b-th variant="warning" colspan="3" class="text-center">FACILITY RECEIVED BY CUSTOMER</b-th>
          </b-tr>
        </template>
      <template v-slot:cell(action)="data">
        <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#" :disabled="(data.item.send2wf==1)" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowApproval(data.item)" href="#" style="padding:0 !important;">Approval</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="(data.item.send2wf==1)" style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>    
        <template v-slot:cell(budget)="data">
          {{data.item.budget|numFormat}}
        </template>
        <template v-slot:cell(cashbackpc)="data">
          {{data.item.cashbackpc|numFormat}} &nbsp;%
        </template>
        <template v-slot:cell(ordered)="data">
            <b-link @click="getDetailOrdered(data.item)">{{data.item.ordered|numFormat}}</b-link>
        </template>
        <template v-slot:cell(delivered)="data">
            <b-link @click="getDetailDelivered(data.item)">{{data.item.delivered|numFormat}}</b-link>
        </template>
        <template v-slot:cell(compliment)="data">
            <b-link @click="getDetailCompliment(data.item)">{{data.item.compliment|numFormat}}</b-link>
        </template>
        <template v-slot:cell(discount)="data">
            <b-link @click="getDetailDiscount(data.item)">{{data.item.discount|numFormat}}</b-link>
        </template>
        <template v-slot:cell(saving)="data">
            <b-link @click="getDetailSaving(data.item)">{{data.item.saving|numFormat}}</b-link>
        </template>
        <template v-slot:cell(paidtoname)="data">
          {{ data.item.paidtoname }}
          <br>
          A/C.{{ data.item.paidtobankno }} &nbsp; &nbsp;{{ data.item.paidtobankname }}
        </template>
        <template v-slot:cell(startdate)="data">
          {{ data.item.startdate | moment("DMMMYYYY") }} s.d {{ data.item.finishdate | moment("DMMMYYYY") }}
          &nbsp; <b-link v-if="(data.item.attchFileNm)" @click="attachmentDownload(data.item)"><i class="fa fa-paperclip"></i></b-link> 
        </template>
        <template v-slot:cell(cashbackpaid)="data">
            <b-link @click="getCashbackPaid(data.item)">{{data.item.cashbackpaid|numFormat}}</b-link>
        </template>
        <template v-slot:cell(issuccess)="data">
          <status-aprroval :dataStatus="data.item"></status-aprroval>  
        </template>

      </b-table>
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
          </b-input-group>
        </b-col>
        <b-col cols="3" >
              <b-pagination align="right"
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
        </b-col>        
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <b-modal v-model="lkuKoranCustShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
      <lku-koran-cust @click="onSelectKoranCust"></lku-koran-cust>
    </b-modal>
    <b-modal v-model="lkuSalesShow" size="lg" :hide-footer="true" title="List of Sales Ex." :centered="true">
      <lku-salesae @click="onSelectsales"></lku-salesae>
    </b-modal>


      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Contact Rpt No.</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomor" readonly></b-form-input>
                    </b-input-group>
                </b-col>
                  <b-col lg="6">                            
                    <b-input-group>
                        <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.createdate"  disabled></b-form-input>                                        
                    </b-input-group>
                </b-col>
            </b-row >    
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                        <b-form-input v-model="model.customer_name" readonly></b-form-input>
                    </b-input-group>
                </b-col>
                  <b-col lg="6">                            
                    <b-input-group>
                        <b-input-group-prepend><label>Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="model.Advertiser"  disabled></b-form-input>                                        
                    </b-input-group>
                </b-col>
            </b-row >    
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Sales AE</label></b-input-group-prepend>
                        <b-form-input v-model="model.salesae_name" readonly></b-form-input>
                    </b-input-group>
                </b-col>
                  <b-col lg="6">                            
                    <b-input-group>
                        <b-input-group-prepend><label>Paid to</label></b-input-group-prepend>
                        <b-form-input v-model="model.paidtoname"  disabled></b-form-input>                                        
                    </b-input-group>
                </b-col>
            </b-row >    
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Sales Commitment</label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text">{{model.matauang}}</span></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text">{{model.budget|numFormat}}</span></b-input-group-prepend>
                    </b-input-group>
                </b-col>
                  <b-col lg="6">                            
                    <b-input-group>
                        <b-input-group-prepend><label>TDP cashback</label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text">{{model.cashbackpc|numFormat}}</span></b-input-group-prepend>
                        <b-input-group-append>
                          <span class="p-2">
                            <i class="fa fa-percent"></i>
                          </span>
                        </b-input-group-append>
                        <b-input-group-prepend><span class="p-2">Value</span></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text">{{model.matauang}}</span></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text">{{model.cashbackval|numFormat}}</span></b-input-group-prepend>
                    </b-input-group>
                </b-col>
            </b-row >             
            <b-input-group >
                <b-input-group-prepend><label>Sales periode</label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text"> {{ model.startdate | moment("DMMMYYYY") }} s.d {{ model.finishdate | moment("DMMMYYYY") }}</span></b-input-group-prepend>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                <b-form-input v-model="model.uraian" readonly></b-form-input>
            </b-input-group>
            <div v-if="(this.model.send2wf==1)">
            <label>Workflow process history</label>
            <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="5" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                  <b-button variant="danger" class="ml-1" v-if="((model.iscomplete==0) || (model.isreject==1) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
              <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                  <label style="width:260px !important;">Send without attachment, are you sure?</label>
                    <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
              </b-row>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>

  </div>
</template>


<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import tdpcr from "../../apis/salestdpcr";
import task from "../../apis/task";
import lkuKoranCust from "../lookup/lkuCustomer";
import lkuSalesae from "../lookup/lkuSalesae";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import moment from "moment";
toastr.init();

export default {
  components: { lkuKoranCust, lkuSalesae },
  data() {
    return {
      actionHistoryShow:false,
      actionHistory:[],     
      showAttachment: false, 
      attachmens:[],
      showDelConfirm: false,
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalCancelConfirm: false,
      lkuKoranCustShow: false,
      lkuSalesShow: false,
      isLoading: false,
      reportUrl: null,
      showReport: false,
      rptLines: [{ collector_id: "" }],
      showFilter:false,      
      limit:15,
      pagination:true,
      tblData: {
        viewOption: 'Header',
        page: 1,
        limit: 15,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: moment().endOf('month').format('YYYY-MM-DD'),
        sortBy: 'nomor',
        sortDesc: true,
      },
      tblFields:[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "CR Number",
            sortable: true
          },
          {
            key: "salesae_name",
            label: "Request By",
            sortable: true
          },
          {
            key: "customer_name",
            label: "Customer Name",
            sortable: true
          },
          {
            key: "customer_code",
            label: "Cust.Code",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "Advertiser",
            label: "Advertiser",
            sortable: true
          },
          {
            key: "startdate",
            label: "Sales Period",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "budget",
            thStyle: "width:100px",
            label: "Sales Commit.",
            thClass: "text-center",
            tdClass: "text-right",
            variant: "primary" ,           
            sortable: true
          },
          {
            key: "cashbackpc",
            label: "TDP %",
            thStyle: "width:40px",
            thClass: "text-center",
            tdClass: "text-right",
            variant: "primary" ,           
            sortable: true
          },
          {
            key: "paidtoname",
            label: "Paid To",
            sortable: true
          },
          {
            key: "issuccess",
            label: "Approval Status",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "ordered",
            thStyle: "width:100px",
            label: "Booked Order",
            thClass: "text-center",
            tdClass: "text-right",
            variant: "success" ,           
            sortable: true
          },
          {
            key: "compliment",
            thStyle: "width:90px",
            label: "Compliment",
            thClass: "text-center",
            tdClass: "text-right",
            variant: "warning" ,           
            sortable: true
          },
          {
            key: "discount",
            thStyle: "width:90px",
            label: "Discount",
            thClass: "text-center",
            tdClass: "text-right",
            variant: "warning" ,           
            sortable: true
          },
          {
            key: "saving",
            thStyle: "width:90px",
            label: "Saving Rate",
            thClass: "text-center",
            tdClass: "text-right",
            variant: "warning" ,           
            sortable: true
          },
          {
            key: "cashbackpaid",
            thStyle: "width:90px",
            label: "TDP Claim Accum.",
            thClass: "text-center",
            tdClass: "text-right",
            variant: "danger" ,           
            sortable: true
          },
        ],
      model:{},
      dataList: {
        openStatus: dropdown.openClose,
        approvalStatus: dropdown.approvalStatus,
      }      

    };
  },
  components: { Loading },
  computed: {
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    }
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
  },
  created: async function() {
      localStorage.setItem("tdpCRMenu", this.$route.name);
      if (this.$route.params.byae==1)  {
        console.log('mode by user');
        this.tblData.createby=this.$store.state.user.username;
      }
  },
  methods: {
    onSelectKoranCust(_selected) {
      this.tblData.customer = _selected.CustCode;
      this.lkuKoranCustShow = false;
    },
    onSelectsales(_selected) {
      this.tblData.sales_search = _selected.salesae_name;
      this.lkuSalesShow = false;
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.customer = "";
      this.tblData.customer_id = "";
      this.tblData.Advertiser = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.nomor = "";
      this.tblData.paidtoname = "";
      this.tblData.sales_search = "";
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    saveFilter() {
      const keys = ['Advertiser', 'brand',  'customer', 'customer_id',  'paidtoname',  'nomor', 'sales_search', 'tgl1', 'tgl2', 'statuswf', 'createby'];
      let filtered = false;
      const tdpcrList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              tdpcrList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          tdpcrList.page=this.tblData.page;
          tdpcrList.limit=this.tblData.limit;
          tdpcrList.sortBy=this.tblData.sortBy;
          tdpcrList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.tdpcrList=tdpcrList;
          this.$store.commit("filter", filter);
      }
    },    
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.tdpcrList) {
            this.tblData[key] = filter.tdpcrList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.tdpcrList.tgl1 || '';
          this.tblData.tgl2=filter.tdpcrList.tgl2 || '';
          this.showFilter=filtered;
          delete filter.tdpcrList;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await tdpcr.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  this.pagination=true;
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }

        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await tdpcr.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  this.pagination=true;
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
        }
    },

    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },
    add: function() {
      this.saveFilter();
      router.push({ name: "sales.tdpcontactrptfrm" });
    },
    edit: function() {
      if (!this.model) {
            toastr.warn('Please select a row that want to be Edit!');
      } else {
        this.saveFilter();
        router.push({
          name: "sales.tdpcontactrptfrm",
          params: { tdpcrkey: this.model.tdpcrkey }
        });
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await tdpcr.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.tdpcrkey==this.model.tdpcrkey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            await tdpcr.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },       
    approvalConfirm: async function () {
        if (this.model.tdpcrkey) {
            if (this.model.send2wf==1) {
                    try {
                      const data = await task.approvalhistory({key: this.model.tdpcrkey});
                      this.approvalHistory=data;                
                    } catch (error) {
                      if (error.message) {
                          toastr.error(error.message,'ERROR MESSAGE',10000);
                      } else {
                          toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                      }                
                    }
            }
            this.model.requestdate = this.model.requestdate ? moment(this.model.requestdate).format('YYYY-MM-DD') : '';
                this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.tdpcrkey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await tdpcr.approval(formData);
            this.model.send2wf=1;
            this.file=null;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await tdpcr.approvalUndo(this.model);
            this.model.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.tdpcrkey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await task.approvalprint({key: this.model.tdpcrkey});
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },   
    print: async function()
    {
      if (this.model.tdpcrkey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await tdpcr.print(this.model);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },   
    exportxls: async function() {
      this.isLoading = true;
      try {
        await tdpcr.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },    
    getDetailOrdered: async function(row) {
      // if (row.ordered > 0) {
      //   this.toggleShowDetailOrder();
      //   this.detailOrder = row;
      // }
      
      const awalTahun = moment(row.startdate).format("YYYY-MM-DD");
      const akhirTahun = moment(row.finishdate).format("YYYY-MM-DD");
      const cust_info = `${row.CustCode+" | "+row.customer_name }`;
      let routeData = router.resolve({path: `sales-order-by-customer/${cust_info}/${row.customer_id}/${awalTahun}/${akhirTahun}`});
      window.open(routeData.href, '_blank');

    },
    getDetailDelivered: async function(row) {
      
      const awalTahun = moment(row.startdate).format("YYYY-MM-DD");
      const akhirTahun = moment(row.finishdate).format("YYYY-MM-DD");
      const cust_info = `${row.CustCode+" | "+row.customer_name }`;
      let routeData = router.resolve({path: `sales-by-customer/${cust_info}/${row.customer_id}/${awalTahun}/${akhirTahun}`});
      window.open(routeData.href, '_blank');
    },
    getDetailCompliment: async function(row) {
      
      const awalTahun = moment(row.startdate).format("YYYY-MM-DD");
      const akhirTahun = moment(row.finishdate).format("YYYY-MM-DD");
      const cust_info = `${row.CustCode+" | "+row.customer_name }`;
      let routeData = router.resolve({path: `compliment-by-customer/${cust_info}/${row.customer_id}/${awalTahun}/${akhirTahun}`});
      window.open(routeData.href, '_blank');
    },
    getDetailDiscount: async function(row) {
      
      const awalTahun = moment(row.startdate).format("YYYY-MM-DD");
      const akhirTahun = moment(row.finishdate).format("YYYY-MM-DD");
      const cust_info = `${row.CustCode+" | "+row.customer_name }`;
      let routeData = router.resolve({path: `sales-discount-by-customer/${cust_info}/${row.customer_id}/1/${awalTahun}/${akhirTahun}`});
      window.open(routeData.href, '_blank');
    },
    getDetailSaving: async function(row) {
      
      const awalTahun = moment(row.startdate).format("YYYY-MM-DD");
      const akhirTahun = moment(row.finishdate).format("YYYY-MM-DD");
      const cust_info = `${row.CustCode+" | "+row.customer_name }`;
      let routeData = router.resolve({path: `saving-by-customer/${cust_info}/${row.customer_id}/1/${awalTahun}/${akhirTahun}`});
      window.open(routeData.href, '_blank');
    },
    getCashbackPaid: async function(row) {
      
      const awalTahun = moment(row.startdate).format("YYYY-MM-DD");
      const akhirTahun = moment(row.finishdate).format("YYYY-MM-DD");
      const cust_info = `${row.CustCode+" | "+row.customer_name }`;
      let routeData = router.resolve({path: `saving-by-customer/${cust_info}/${row.customer_id}/1/${awalTahun}/${akhirTahun}`});
      window.open(routeData.href, '_blank');
    },
    close() {
      router.push({name: "sales.home"});
    }
  }
};
</script>
